var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagnifyingglass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.53425 12.9448C7.95327 12.9448 9.26182 12.4903 10.3324 11.7328L14.3601 15.7223C14.547 15.9074 14.7934 16 15.0568 16C15.6091 16 16 15.5792 16 15.0405C16 14.788 15.915 14.5439 15.7281 14.3672L11.726 10.3945C12.5672 9.30037 13.0685 7.94529 13.0685 6.47238C13.0685 2.91215 10.1285 0 6.53425 0C2.94849 0 0 2.90373 0 6.47238C0 10.0326 2.93999 12.9448 6.53425 12.9448ZM6.53425 11.5476C3.73022 11.5476 1.41052 9.24987 1.41052 6.47238C1.41052 3.6949 3.73022 1.39716 6.53425 1.39716C9.33829 1.39716 11.658 3.6949 11.658 6.47238C11.658 9.24987 9.33829 11.5476 6.53425 11.5476Z",
    fill: "#8592C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingglass);
export default __webpack_public_path__ + "static/media/magnifyingglass.b1ad514b4bad16d15088af246ef6b0d9.svg";
export { ForwardRef as ReactComponent };